import { render, staticRenderFns } from "./SegmentedMultiposition.vue?vue&type=template&id=2f28469f&scoped=true"
import script from "./SegmentedMultiposition.vue?vue&type=script&setup=true&lang=ts"
export * from "./SegmentedMultiposition.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SegmentedMultiposition.vue?vue&type=style&index=0&id=2f28469f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f28469f",
  null
  
)

export default component.exports